import { render, staticRenderFns } from "./SsoResetPassword.vue?vue&type=template&id=8092338e&scoped=true&"
import script from "./SsoResetPassword.vue?vue&type=script&lang=ts&"
export * from "./SsoResetPassword.vue?vue&type=script&lang=ts&"
import style0 from "./SsoResetPassword.vue?vue&type=style&index=0&id=8092338e&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8092338e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardActions,VCardText,VCardTitle,VCol,VForm,VRow,VSpacer})
